import { EmptyObject } from 'libs/end-to-end/src/generic';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { TimeSeriesTrendsResult } from 'libs/end-to-end/src/custom-viz/TimeSeriesTrendsTypes';

export const TimeSeriesTrendsCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'timeSeriesTrends',
  outputFileName: 'time_series_trends_result.json',
  isDataQueuingAllowed: true,
  outputSchema: TimeSeriesTrendsResult,
  extrasSchema: EmptyObject,
  resolveFocusArea: () => null,
  resolveFilters: (customVizRequest) => {
    if (customVizRequest.customVizId !== 'timeSeriesTrends') {
      throw new Error('Invalid custom viz ID');
    }
    return customVizRequest.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'timeSeriesTrends') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      'Selected Dimensions': [],
      Filters: request.inputs.extras.filters,
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'progress/trends',
};
